import { HelpMessage } from 'utils/constants'
import { ConcretePlacement } from '../../../types'
import SubTable from './SubTable'

const FirstTable: React.FC<ConcretePlacement> = (record) => {
  const help = HelpMessage.Concrete.ConcreteTestSetTracker.Placements
  return (
    <SubTable
      concretePlacement={record}
      which="first"
      columns={[
        {
          title: 'Cubic Yards',
          help: help.CubicYards,
          width: 118,
          render: 'placementQtyVolCy',
        },
        {
          title: 'Lineal Feet',
          help: help.LinealFeet,
          width: 107,
          render: 'linearFt',
        },
        {
          title: 'Square Feet',
          help: help.SquareFeet,
          width: 115,
          render: ({ sqFt }) => sqFt?.toFixed(1),
        },
        {
          title: 'Square Yards',
          help: help.SquareYards,
          width: 121,
          render: ({ sqYd }) => sqYd?.toFixed(1),
        },
        {
          title: 'Required Thickness',
          help: help.RequiredThickness,
          width: 161,
          render: 'requiredThickness',
        },
      ]}
    />
  )
}

export default FirstTable
